{
	"title": "Today at my venue",
	"loading": "Loading the day…",
	"heading": "{{venue}}, {{day}}",
	"headingToday": "{{venue}}, today",
	"subtitle": "{{games}}, {{date}}. This device remembers your venue. Use ↑ and ↓ to move between meets, Enter to open one.",
	"outsideGames": "This day is outside the games' dates.",
	"context": {
		"legend": "Venue and day",
		"venue": "Venue",
		"day": "Day",
		"pickVenue": "Pick a venue",
		"previousDay": "Previous day",
		"nextDay": "Next day"
	},
	"errors": {
		"contextTitle": "The games and venues could not load",
		"scheduleTitle": "The day's meets could not load",
		"retry": "Try again"
	},
	"empty": {
		"noGamesTitle": "No games are set up yet",
		"noGamesBody": "Games are created in GMS. Ask your administrator.",
		"noVenuesTitle": "No venues are set up yet",
		"noVenuesBody": "Venues are created in GMS. Ask your administrator.",
		"noMeetsTitle": "No meets at {{venue}} on {{day}}",
		"noMeetsBody": "Pick another day or another venue at the top of this page."
	},
	"chooseVenue": {
		"title": "Which venue are you at?",
		"body": "Pick it once. This device remembers it, and you can change it at the top of this page."
	},
	"counts": {
		"label": "The day at a glance",
		"meets_one": "meet",
		"meets_other": "meets"
	},
	"timeline": {
		"label": "Meets in start order",
		"now": "Now",
		"open": "Open",
		"where": "{{sport}} › {{event}} › {{phase}}",
		"later": "Show later meets",
		"allDone": "Every meet of this day is official, cancelled or postponed.",
		"meetNo": "Meet {{meet}}"
	},
	"summary": {
		"toBeDecided": "To be decided",
		"noStartList": "No start list yet",
		"versus": "v",
		"competitors_one": "{{count}} competitor",
		"competitors_other": "{{count}} competitors",
		"leader": "Leading:"
	},
	"unscheduled": {
		"title": "Not scheduled yet",
		"hint": "These meets have no start time. Times are set in GMS.",
		"previous": "Previous",
		"next": "Next",
		"page": "Page {{page}} of {{pages}}"
	}
}
